import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chatbot-loader" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  rx: "4",
  ry: "4",
  width: "270",
  height: "24"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "34",
  rx: "4",
  ry: "4",
  width: "219",
  height: "18"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "136",
  r: "12"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "48",
  cy: "136",
  r: "12"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "84",
  cy: "136",
  r: "12"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  x: "208",
  y: "130",
  rx: "4",
  ry: "4",
  width: "80",
  height: "14"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_md_card, {
      variant: "filled",
      style: {"height":"180px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_content_loader, {
          viewBox: "0 0 288 148",
          speed: 1.2,
          primaryColor: "#dad9e3",
          secondaryColor: "#cecdd8"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }, 8, ["speed"])
      ]),
      _: 1
    })
  ]))
}